module.exports = __webpack_public_path__ + "static/media/sello_rp_delonia.7079bd2c.png";